import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  VacationScheduleSupervisor,
  VacationScheduleSupervisorPaginated,
  vacationsScheduleSupervisorApi,
} from 'app/services/edpApiV1/supervisor/vacationsSchedule';

interface TInitialState extends VacationScheduleSupervisorPaginated {
  loading: boolean;
  success: boolean;
  error?: string;
  currentVS?: VacationScheduleSupervisor;
}

const initialState: TInitialState = {
  data: [],
  pagination: { page: 1, size: 10, total: 0 },
  loading: false,
  success: false,
};

export const vacationScheduleSupervisorSlice = createSlice({
  name: 'vacationScheduleSupervisor',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.vacationsScheduleDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.vacationsScheduleDeputy.matchRejected, () => initialState)
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.vacationsScheduleDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.vacationsScheduleActing.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.vacationsScheduleActing.matchRejected, () => initialState)
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.vacationsScheduleActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.vacationsScheduleSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.vacationsScheduleSupervisor.matchRejected,
        () => initialState,
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.vacationsScheduleSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisor>) => {
          state.currentVS = payload;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleDeputy.matchRejected,
        () => initialState,
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleActing.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisor>) => {
          state.currentVS = payload;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleActing.matchRejected,
        () => initialState,
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<VacationScheduleSupervisor>) => {
          state.currentVS = payload;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(
        vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleSupervisor.matchRejected,
        () => initialState,
      )
      .addMatcher(vacationsScheduleSupervisorApi.endpoints.singleVacationsScheduleSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      });
  },
});

const vacationSchedule = (state: RootState) => state.entities.supervisor.vacationScheduleApplicationSupervisorReducer;
export const getVacationCheduleSupervisor = createSelector(vacationSchedule, state => state);
export const getSingleVacationScheduleSupervisor = createSelector(vacationSchedule, state => state.currentVS);

export const actions = vacationScheduleSupervisorSlice.actions;
export const reducer = vacationScheduleSupervisorSlice.reducer;
